import React from "react";
import { Form, Button } from "react-bootstrap";
import "./login.css";


const Login = ({ handleModal }) => {


    return (
        <div className="login">
            <div className="login-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="login-form">
                                <h1>Log In</h1>
                                <p>Welcome, Please login to your account</p>
                                <div className="login-box">
                                    <Form>
                                        <Form.Group controlId="formBasicFirst">
                                            <Form.Label>Username / Email</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter your username or email"
                                                name="phone"
                                                autoComplete="off"
                                            />
                                        </Form.Group>
                                        <Form.Group controlId="formBasicPassword">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="Enter your password"
                                                name="password"
                                                autoComplete="off"

                                            />
                                        </Form.Group>
                                        <div className="forget-password">
                                            <div className="remember-me">
                                                <Form.Check type="checkbox" label="Remember me" />
                                            </div>
                                            <Button className="forget-link" onClick={()=>handleModal("forget")}>
                                                Forget Password?
                                            </Button>
                                        </div>
                                        <div className="login-button">
                                            <Button type="submit" className="l-btn" >
                                                Login
                                            </Button>
                                        </div>
                                        <div className="social-login">
                                            <span>OR</span>
                                            <div className="social-btns">
                                                <Button className="facebook-btn"><i className="fa fa-facebook" /> Login with Facebook</Button>
                                                <Button className="twitch-btn"><i className="fa fa-steam" /> Login with Steam</Button>
                                            </div>
                                        </div>
                                    </Form>
                                    <p className="already">Don't have an account yet? <Button className="forget-link" onClick={()=>handleModal("register")}>
                                        Register
                                </Button>  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
